export default {
      id: "icon-support-usage",
      viewBox: "-3 -3 28 28",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-support",
      toString: function () {
        return this.url;
      }
    }